<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Outlet Refrigerator</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Outlet Code</span>
                            <v-text-field maxlength="10" v-model="editedItem.name" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex>-1" :rules="reqRule"></v-text-field>
                        </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4">Type Refrigerator</v-col>
                          <v-col cols="3">Quantity</v-col>
                          <v-col cols="2"></v-col>
                        </v-row>
                        <v-row v-for="(obj, idx) in editedItem.details" :key="idx">
                          <v-col cols="4">
                            <v-autocomplete filled rounded dense :items="refrigerators" item-text="refrigerator_name" item-value="code" v v-model="obj.refrigerator_code" hide-details="auto" @change="fillRefrigerator(obj)" autocomplete="off" :rules="reqRule" auto-select-first></v-autocomplete>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field type="number" v-model="obj.quantity" filled rounded dense hide-details="auto" :rules="reqRule" @wheel="$event.target.blur()"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-icon color="red" class="pt-1" @click="removeRefrigeratorDetails(idx)">
                                mdi-minus-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold body-1 pl-4"></v-col>
                          <v-col cols="3" class="font-weight-bold body-1 pl-4"></v-col>
                          <v-col cols="3"></v-col>
                          <v-col cols="2" class="">
                            <v-btn color="primary" outlined text @click="addRefrigeratorDetails()">Add</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus Data ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="700px">
                <v-card>
                    <v-card-title class="">
                      <span class="text-h6">Outlet Refrigerator Detail</span>
                      <v-spacer></v-spacer>
                      <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Outlet:</v-col>
                          <v-col cols="8">{{ detailItem.name }}</v-col>
                        </v-row>
                        <v-divider class="my-3"></v-divider>
                        <v-row>
                          <v-col cols="12" class="font-weight-bold text-h6">Refrigerators</v-col>
                        </v-row>
                        <v-row v-if="detailItem.refrigerators && detailItem.refrigerators.length > 0">
                          <v-col cols="12">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">No</th>
                                    <th class="text-left">Refrigerator Name</th>
                                    <th class="text-left">Capacity</th>
                                    <th class="text-center">Quantity</th>
                                    <th class="text-center">Total Capacity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(ref, idx) in detailItem.refrigerators" :key="idx">
                                    <td>{{ idx + 1 }}</td>
                                    <td>{{ getRefrigeratorName(ref.refrigerator_code) }}</td>
                                    <td>{{ getRefrigeratorCapacity(ref.refrigerator_code) }}</td>
                                    <td class="text-center">{{ ref.quantity }}</td>
                                    <td class="text-center">{{ getRefrigeratorCapacity(ref.refrigerator_code) * ref.quantity }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" class="text-center grey--text">
                            Belum ada refrigerator
                          </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
        </v-data-table>
        <v-overlay :value="onProgress" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        
        <v-snackbar top v-model="saved" color="green">Data berhasil tersimpan!</v-snackbar>
        <v-snackbar top v-model="saveError" color="red accent-2">Data gagal tersimpan! Mohon pastikan data yang akan disimpan sudah sesuai.</v-snackbar>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      headers: [
        { text: 'Outlet', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {
        details: []
      },
      defaultItem: {
      },
      search: '',
      refrigerators: [],
      reqRule: [v => !!v || 'Harus diisi!'],
      valid: true,
      onProgress: false,
      saved: false,
      saveError: false,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Refrigerator' : 'Edit Refrigerator'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.refrigerators = (await this.$store.dispatch('refrigerator/getObjs')).data.data
        let response = await this.$store.dispatch('outletrefrigerator/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },

      async loadDataTable() {
        let response = await this.$store.dispatch('outletrefrigerator/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },

      getRefrigeratorName(code) {
        const refrigerator = this.refrigerators.find(element => element.code == code);
        return refrigerator ? refrigerator.refrigerator_name : '-';
      },

      getRefrigeratorCapacity(code) {
        const refrigerator = this.refrigerators.find(element => element.code == code);
        return refrigerator ? refrigerator.refrigerator_capacity : 0;
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },

      fillRefrigerator(obj) {
        obj.refrigerator_name = (this.refrigerators.find(element=> {
          return element.code == obj.refrigerator_code
        })).refrigerator_name
      },

      addRefrigeratorDetails() {
        let details = {refrigerator_code: '', quantity: ''}
        this.editedItem.details.push(details)
      },

      removeRefrigeratorDetails(idx) {
        console.log(idx)
        this.editedItem.details.splice(idx, 1)
        console.log(this.editedItem.details, idx)
      },

      async editItem (item) {
        this.onProgress = true
        this.editedItem = {
          code: item.code,
          name: item.name,
          details: []
        }
        item.refrigerators.forEach(element => {
          this.editedItem.details.push({
            refrigerator_code: element.refrigerator_code,
            quantity: element.quantity
          })
        });
        this.editedIndex = this.items.indexOf(item)
        this.dialog = true
        this.onProgress = false
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "outlet-refrigerators/" + this.editedItem.code
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "outlet-refrigerators/" + this.editedItem.code
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status == 'success') {
            Object.assign(this.items[this.editedIndex], this.editedItem)

            this.loadDataTable()
          }
          
          this.close()
          
          this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Outlet Refrigerator berhasil diupdate'})
        } else {
          try {
            let url = this.$store.state.config.apiHost + "outlet-refrigerators"
            let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success') this.items.push(this.editedItem)
            this.close()
          }
          catch (err) {
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
      },
      resetForm() {
          this.$refs.form.reset();
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>